import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/apps/capeX/src/app/providers/session.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderNav"] */ "/vercel/path0/apps/capeX/src/components/layout/HeaderNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SideNav"] */ "/vercel/path0/apps/capeX/src/components/layout/SideNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetTrigger","SheetContent"] */ "/vercel/path0/apps/capeX/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/capeX/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/capeX/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
